import { render, staticRenderFns } from "./VaButtonGroup.vue?vue&type=template&id=797d7644&"
import script from "./VaButtonGroup.vue?vue&type=script&lang=js&"
export * from "./VaButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./VaButtonGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports